// extracted by mini-css-extract-plugin
export var skipAnimation = "_l-0";